import { render, staticRenderFns } from "./Page_AlgoliaSearchResults.vue?vue&type=template&id=64baae26&scoped=true&"
import script from "./Page_AlgoliaSearchResults.vue?vue&type=script&lang=js&"
export * from "./Page_AlgoliaSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./Page_AlgoliaSearchResults.vue?vue&type=style&index=0&id=64baae26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64baae26",
  null
  
)

export default component.exports